// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a9361ead","453":"d1d66f0e","455":"5abd2d95"}[chunkId] + ".chunk.js";
};